interface SkeletonProps {
  className?: string
  count?: number
  height?: string
  width?: string
}

export function Skeleton({ className, count = 1, height = 'h-4', width = 'w-full' }: SkeletonProps) {
  if (count <= 1) {
    return <div className={`animate-pulse rounded bg-slate-200 ${height} ${width} ${className ?? ''}`} />
  }

  return (
    <div className={`space-y-2 ${className ?? ''}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={`animate-pulse rounded bg-slate-200 ${height} ${width}`} />
      ))}
    </div>
  )
}

export function ThreatCardSkeleton() {
  return (
    <article className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton className="w-40" />
          <Skeleton className="w-28 h-3" />
        </div>
        <Skeleton className="h-8 w-16" />
      </div>

      <div className="mt-4 space-y-2">
        <Skeleton className="h-3 w-28" />
        <Skeleton count={2} className="w-full" />
      </div>

      <div className="mt-4 space-y-2">
        <Skeleton className="h-3 w-24" />
        <Skeleton count={2} className="w-full" />
      </div>

      <div className="mt-4 space-y-2">
        <Skeleton className="h-3 w-36" />
        <Skeleton className="h-4 w-full" />
      </div>
    </article>
  )
}

export function KPISkeleton() {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <Skeleton className="h-3 w-32" />
      <Skeleton className="mt-2 h-8 w-20" />
      <Skeleton className="mt-2 h-3 w-40" />
      <Skeleton className="mt-3 h-10 w-full" />
    </div>
  )
}

export function ClusterSkeleton() {
  return (
    <article className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-center gap-2">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-5 w-28" />
      </div>
      <Skeleton className="mt-3 h-4 w-5/6" />
      <Skeleton className="mt-2 h-4 w-2/3" />
      <div className="mt-3 flex items-center justify-between border-t border-slate-100 pt-3">
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-3 w-24" />
      </div>
    </article>
  )
}
